import React from 'react';

import { flagStyles } from '../settings';

const SvgCG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-960px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCG;
